<template>
    <ul class="vList vList_x5_LG">
        <li v-for="(subcategory, index) in subcategories" v-if="filterToSubcategory(subcategory).length" :key="index">
            <h2 class="hdg hdg_2 vr_4 m-text_center" >
                {{subcategory}}
            </h2>
            <drawer-grid :items="filterToSubcategory(subcategory)" :preview-text="previewText"></drawer-grid>
        </li>
    </ul>
</template>
<script>

import DrawerGrid from 'components/list/DrawerGrid.vue';

export default {
  props: ['items','previewText'],
  components: {
      DrawerGrid,
  },
  created() {
      this.subcategories = this.getSubcategories();
  },
  data() {
      return {
          subcategories: null
          }
  },

  methods: {
    toggleActiveItem(index, closeOnly) {
        if(this.activeItem == index || closeOnly) {
            this.activeItem = null;
            return;
        }

        this.activeItem = index;
    },
    getSubcategories() {
          let subcategories = [];
          for (let i = 0; i < this.items.length; i++) {
              this.items[i].subcategory
              if(subcategories.indexOf(this.items[i].subcategory) == -1) {
                  subcategories.push(this.items[i].subcategory);
              }
          }
          return subcategories;
      },
    filterToSubcategory(subcategory) {
        let itemsInSubcategory = [];
        for (let i = 0; i < this.items.length; i++) {
              if(this.items[i].subcategory == subcategory) {
                  itemsInSubcategory.push(this.items[i]);
              }
          }
          return itemsInSubcategory;
    }
  }

};
</script>

<style lang="scss">

</style>

